import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Box, Card, CardContent, Divider, IconButton, Typography } from '@mui/material';

//import makeStyles from '@mui/styles/makeStyles';
import { styled } from '@mui/material/styles';

//const useStyles = makeStyles(() => ({
const RootCardContainer = styled(Card)({
  display: 'flex',
  flexDirection: 'column'
});

const CTCard = ({ className, summary, ...rest }) => {

  return (
    <RootCardContainer
      className={className}
      {...rest}
    >
      <CardContent>
        <Typography
          align="center"
          color="textPrimary"
          gutterBottom
          variant="h5"
        >
          {summary.content}
        </Typography>
        <Typography
          align="center"
          color="textSecondary"
          variant="body1"
        >
          {summary.title.toUpperCase()}
        </Typography>
      </CardContent>
      <Box flexGrow={1} />
      <Divider />
      {summary.action && summary.second_action ?
        <Box style={{display:'flex', justifyContent:'space-around'}}>
          <Typography
            align="center"
            variant="body1"
          >
            {summary.action.name}
            <IconButton aria-label="money" color="primary" fontSize="small" size="large">
              {summary.action.icon}
            </IconButton>
          </Typography>
          <Typography
            align="center"
            variant="body1"
          >
            {summary.second_action.name}
            <IconButton aria-label="money" fontSize="small" style={{color: 'red'}} size="large">
              {summary.second_action.icon}
            </IconButton>
          </Typography>
        </Box> :
        <Box>
          <Typography
            align="center"
            variant="body1"
          >
            {summary.action.name}
            <IconButton aria-label="money" color="primary" fontSize="small" size="large">
              {summary.action.icon}
            </IconButton>
          </Typography>
        </Box>
      }
    </RootCardContainer>
  );
};

CTCard.propTypes = {
  className: PropTypes.string,  
};

export default CTCard;